export default "__VITE_ASSET__920f3332__"